"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Card = _interopRequireDefault(require("../Card"));

var _CardActions = _interopRequireDefault(require("../CardActions"));

var _CardButton = _interopRequireDefault(require("../Buttons/CardButton"));

var _Headings = require("../Headings");

var _Paragraph = require("../Paragraph");

var _HR = _interopRequireDefault(require("../HR"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  wrapper: {
    outline: 0
  },
  message: {
    fontSize: '1rem',
    padding: 40,
    textAlign: 'center',
    maxHeight: 300,
    overflow: 'auto',
    fontFamily: 'Circular Pro'
  }
}));
const Message = (0, _styledComponents.default)(_Paragraph.P)`
	padding: 40px;
	text-align: center;
	max-height: 300px;
	overflow: auto;
`;
const Title = (0, _styledComponents.default)(_Headings.Subtitle1)`
	padding: 30px;
	padding-top: 21px;
	padding-bottom: 16px;
`;

const ConfirmationModal = ({
  closeLabel,
  actionLabel,
  title,
  message,
  handleConfirm,
  handleCancel,
  handleClose,
  ...props
}) => {
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Modal, _extends({
    open: true,
    onClose: handleClose,
    className: classes.modal
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement(_Card.default, null, title && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Title, null, title), /*#__PURE__*/_react.default.createElement(_HR.default, null)), /*#__PURE__*/_react.default.createElement(Message, null, message), /*#__PURE__*/_react.default.createElement(_CardActions.default, {
    disableSpacing: true
  }, /*#__PURE__*/_react.default.createElement(_CardButton.default, {
    onClick: handleCancel
  }, closeLabel), handleConfirm && /*#__PURE__*/_react.default.createElement(_CardButton.default, {
    primary: true,
    onClick: handleConfirm
  }, actionLabel)))));
};

ConfirmationModal.propTypes = {
  closeLabel: _propTypes.default.string,
  actionLabel: _propTypes.default.string,
  title: _propTypes.default.string,
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  handleConfirm: _propTypes.default.func,
  handleCancel: _propTypes.default.func.isRequired
};
ConfirmationModal.defaultProps = {
  closeLabel: 'Close',
  actionLabel: 'Yes',
  title: '',
  handleConfirm: null
};
var _default = ConfirmationModal;
exports.default = _default;